<template>
  <order-form mode="add" :source-id="$route.query.sourceId || ''" />
</template>

<script>
import OrderForm from "./components/order-form.vue";

export default {
  name: "workOrderAdd",
  components: { OrderForm },
};
</script>
